export enum ProfileExtrusionType {
  NONE = "NONE",
  DEFAULT_PROFILE = "DEFAULT_PROFILE",
  EXTERIOR_TRANSITION_BOARD_TRIM_PROFILE = "EXTERIOR_TRANSITION_BOARD_TRIM_PROFILE",
  DRIP_CAP_PROFILE = "DRIP_CAP_PROFILE",
  ROWLOCK_BRICK = "ROWLOCK_BRICK",
  ROWLOCK_OVER_SOLDIER_BRICK = "ROWLOCK_OVER_SOLDIER_BRICK",
  TRIM_BOARD_1_2 = "TRIM_BOARD_1_2",
  TRIM_BOARD_1_3 = "TRIM_BOARD_1_3",
  TRIM_BOARD_1_4 = "TRIM_BOARD_1_4",
  TRIM_BOARD_1_6 = "TRIM_BOARD_1_6",
  TRIM_BOARD_1_8 = "TRIM_BOARD_1_8",
  TRIM_BOARD_1_10 = "TRIM_BOARD_1_10",
  TRIM_BOARD_1_12 = "TRIM_BOARD_1_12",
  TRIM_REVEAL_1 = "TRIM_REVEAL_1",
  TRIM_CAP_1_2 = "TRIM_CAP_1_2",
  TRIM_VERT_1_60 = "TRIM_VERT_1_60",
  CROWN_4_FRIEZE_6 = "CROWN_4_FRIEZE_6",
}

export enum ProfileExtrusionDescriptorType {
  BOARD = "BOARD",
  CUSTOM = "CUSTOM",
}
